//To concate the path for the public folder
export const toAbsoluteUrl = (pathname: string) =>
  process.env.PUBLIC_URL + pathname;
